import branding from 'shared/app/model/branding';
import { is_paid_tariff } from '../billing/billing-utils';
export function can_manage_groups(state) {
    return is_paid_tariff(state);
}
export function can_locate_device(state) {
    if (branding.enable_zont_billing) {
        return is_paid_tariff(state);
    }
    return true;
}
export function can_write_individual_name(state) {
    if (branding.enable_zont_billing) {
        return is_paid_tariff(state);
    }
    return false;
}
export function can_use_config_history(state) {
    if (state.account.is_staff) {
        return true;
    }
    if (branding.enable_zont_billing) {
        return is_paid_tariff(state);
    }
    return false;
}
export function can_create_task_for_cron(state) {
    if (branding.enable_zont_billing) {
        return is_paid_tariff(state);
    }
    return false;
}
export function can_send_to_test_server(state) {
    if (state.account.is_superuser) {
        return true;
    }
    if (state.account.permissions?.includes('admin_can_send_to_test_server')) {
        return true;
    }
    return false;
}
